<template>
	<div>
		<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
			<freeUserTips :type="4" :bgtype="0"></freeUserTips>
		</el-dialog>
		<dl class="opport-screen bdbe" style="padding-top: 10px">
			<dt class="fl" style="margin-top: 24px">{{ dlname }}时间</dt>
			<dd class="fl">
				<div class="clue_finantime" v-show="timetype != 3">
					<h3 :style="'padding-left:' + titlesize + 'px;'">{{yearLabel}}年</h3>
					<span :key="i" v-for="(item, i) in financingTime" @click="chooseFun(item, i)" :class="{
						'a-screen': true,
						current: finantime == item.time,
						borderrightt: i == borderindex,
					}">{{ item.text }}</span>
				</div>
				<div class="clue_finantime" v-show="timetype == 3">
					<h3 style="padding-left: 40px">2023年</h3>
					<span :key="i" v-for="(item, i) in financingTime" @click="chooseFun(item, i)" :class="{
						'a-screen': true,
						current: finantime == item.time,
						borderrightt: i == 0,
					}">{{ item.text }}</span>
				</div>
				<el-tooltip class="item smartTip-text listeltootipicon" effect="light" placement="top-start"
					v-show="showTips">
					<i class="el-icon-question"></i>
					<div slot="content" class="list_tips">
						{{ dlname }}时间：最近一年获得{{ dlname }}的企业
					</div>
				</el-tooltip>
			</dd>
		</dl>
	</div>
</template>
<script>
import { getMonthLength } from "@/utils/common.js";
export default {
	name: "zpagenav",
	data() {
		return {
			userdata: {}, //每个月都要修改  updatetime
			isShowFreeUserTips: false,
			finantime: "year",
			finantime2: "",
			financingTime: [],
			financingTime1: [
				//手动添加时间 每月1号后新增新的月份{time:"2021-07",text:'7月'},{time:"2021-09",text:'9月'},
				{ time: "year", text: "全部" },
				{ time: "2023-12", text: "12月" },
				{ time: "2024-01", text: "1月" },
				{ time: "2024-02", text: "2月" },
				{ time: "2024-03", text: "3月" },
				{ time: "2024-04", text: "4月" },
				{ time: "2024-05", text: "5月" },
				{ time: "2024-06", text: "6月" },
				{ time: "2024-07", text: "7月" },
				{ time: "2024-08", text: "8月" },
				{ time: "2024-09", text: "9月" },
				{ time: "2024-10", text: "10月" },
				{ time: "2024-11", text: "11月" },
			],
			financingTime2: [
				//手动添加时间 每月十五号后新增新的月份{time:"2021-07",text:'7月'},{time:"2021-09",text:'9月'},
				{ time: "year", text: "全部" },
				{ time: "2023-12", text: "12月" },
				{ time: "2024-01", text: "1月" },
				{ time: "2024-02", text: "2月" },
				{ time: "2024-03", text: "3月" },
				{ time: "2024-04", text: "4月" },
				{ time: "2024-05", text: "5月" },
				{ time: "2024-06", text: "6月" },
				{ time: "2024-07", text: "7月" },
				{ time: "2024-08", text: "8月" },
				{ time: "2024-09", text: "9月" },
				{ time: "2024-10", text: "10月" },
				{ time: "2024-11", text: "11月" },
			],
			financingTime3: [
				//固定的，暂时不需要定时更新
				{ time: "year", text: "全部" },
				{ time: "1", text: "1月" },
				{ time: "2", text: "2月" },
				{ time: "3", text: "3月" },
				{ time: "4", text: "4月" },
				{ time: "5", text: "5月" },
				{ time: "6", text: "6月" },
				{ time: "7", text: "7月" },
				{ time: "8", text: "8月" },
				{ time: "9", text: "9月" },
				{ time: "10", text: "10月" },
				{ time: "11", text: "11月" },
				{ time: "12", text: "12月" },
			],
			titlesize: 0, //标题的向左位移值
			borderindex: 0, //标题的边框索引值
			yearLabel: "", //年份标签
		};
	},
	props: {
		dlname: { type: String, default: "融资" },
		type: { type: String, default: "month" }, //默认为月份 比如2023-03 有些需要日期 比如2023-03-01
		timetype: { type: Number, default: 1 }, //更新时间不一样
		showTips: { type: Boolean, default: true }, //是否显示小问号提示
	},
	computed: {},
	created() {
		this.userdata = this.getuseriformation();
		// console.log('调用时间',this.timetype)
		if (this.timetype == 1) {
			this.financingTime = this.getLastSixMonthsDates();
			// this.titlesize = 100;
			// this.borderindex = 1;
		} else if (this.timetype == 2) {
			this.financingTime = this.getLastSixMonthsDates();
			// this.titlesize = 100;
			// this.borderindex = 1;
		} else if (this.timetype == 3) {
			this.financingTime = this.financingTime3;
		}
	},
	methods: {
		//获取最一年的时间
		getLastSixMonthsDates() {
			const today = new Date(); // 获取当前日期
			let previousYear = null; // 用于记录上一次的年份
			const result = []; // 用于存储结果的数组

			// 循环12次，每次计算一个月
			for (let i = 11; i >= 0; i--) {
				// 获取过去第i个月的15号
				const date = new Date(today.getFullYear(), today.getMonth() - i, 15);

				// 检查日期是否正确，如果日期被调整（如2月29日），手动修正为2月最后一天
				if (date.getDate() !== 15) {
					date.setDate(0); // 将日期设置为上个月的最后一天
				}

				// 格式化年份和月份
				const year = date.getFullYear();
				const month = date.getMonth() + 1; // 月份从0开始，需要加1

				// 检查是否是该年份的第一个数据
				const isFirstOfYear = previousYear === null || year !== previousYear;

				// 更新上一次的年份
				previousYear = year;

				// 构造对象并添加到结果数组中
				result.push({
					time: `${year}-${month}`, // 不加前导零
					text: `${month}月`,      // 不加前导零
					isFirstOfYear: isFirstOfYear // 添加标识
				});

				// 如果是新年开始，更新 size
				if (isFirstOfYear) {
					this.yearLabel = year; // 更新年份标签
					this.borderindex = result.length - 2; // 将当前下标赋值给 size
					this.titlesize = (result.length - 2) * 65;
				}
			}
		console.log('result',result, this.borderindex, this.titlesize,this.yearLabel)
			return result; // 返回结果数组
		},
		chooseFun: function (item, i) {
			if (!this.userdata.token) {
				this.isShowFreeUserTips = true;
				return;
			}
			if (this.finantime == item.time) {
				return;
			} else {
				this.finantime = item.time;
				this.$emit("chooseFinancing", this.finantime);
			}
			// if(this.finantime!=item.time) {
			// 	this.finantime=item.time;
			// 	var len=this.financingTime.length-1;
			// 	if(this.finantime!= 'all' & i != len){
			// 		this.finantime2=this.financingTime[i+1].time;
			// 	}else if(this.finantime == ''){
			// 		this.finantime2=this.financingTime[len].time;
			// 	}else if(i == len){
			// 			this.finantime2="";
			// 	}
			// 	// this.$emit('chooseFinancing', this.finantime,this.finantime2);

			// }
		},
		getFinancingTime(item, i) {
			//作废
			if (this.finantime == item.time) {
				return;
			} else {
				this.finantime = item.time;
				var timeObj = { date1: "2023-03", date2: "2024-02" };
				if (item.time == "all") {
					timeObj = { date1: "2023-03", date2: "2024-02" };
				} else {
					timeObj = { date1: item.time, date2: item.time };
				}
				if (this.type == "day") {
					timeObj.date1 = item.time + "-01";
					timeObj.date2 = item.time + "-" + getMonthLength(item.time);
				}
				console.log(timeObj);
				// this.$emit('chooseFinancing', timeObj.date1,timeObj.date2);
			}
		},
	},
};
</script>

<style>
.jump {
	display: inline-block;
	margin-left: 20px;
	font-size: 14px;
}

.jumppage {
	border: 1px solid #eeeeee;
	width: 50px;
	height: 30px;
	margin: 0px 10px;
	border-radius: 4px;
	text-align: center;
}

.jumppage_btn {
	cursor: pointer;
	display: inline-block;
	width: 70px;
	height: 30px;
	background-color: #3e7bfa;
	border-radius: 4px;
	color: #ffffff;
	line-height: 30px;
	margin-left: 10px;
}
</style>
